import React, { useState } from "react";
import { Fragment } from "react";
import Footer from "../../../Shear/Footer/Footer";
import Header from "../../../Shear/Header/Header";
import Loading from "../../../Shear/Loading/Loading";
import CourseLessonLeft from "./CourseLessonLeft";
import CourseLessonRight from "./CourseLessonRight";
import { useSignOut } from "react-firebase-hooks/auth";
import auth from "../../../../FirebaseInit/FirebaseInit";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";

const CourseLesson = () => {
  const [video, setVideo] = useState("");
  const [load, setLoad] = useState(false);

  const navigate = useNavigate();
  const [signOut] = useSignOut(auth);
  const [items, setItems] = useState([]);
  useEffect(() => {
    setLoad(true);
    fetch(`https://server.globalitmaster.com/app/v1/course`, {
      method: "GET",
      headers: {
        authorization: `Bearer ${localStorage.getItem("accessToken")}`,
      },
    })
      .then((response) => {
        if (response?.status === 401 || response?.status === 403) {
          localStorage.removeItem("accessToken");
          signOut();
          navigate("/");
        }

        return response.json();
      })
      .then((json) => {
        if (json.status === 200) {
          setItems(json.data);
          setVideo(json.data[0].videos);
          setLoad(false);
        }
      });
  }, [signOut, navigate]);

  return (
    <Fragment>
      <Header />
      {load ? (
        <Loading />
      ) : (
        <section className="bg-[#F7F8FD]">
          {" "}
          <h2 className="text-center text-lg max-md:text-[30px]  text-linear-gradient font-bold font-fira py-5">
            Completed Web Development Course Batch1
          </h2>
          <div className="max-w-[1200px] mx-auto pb-20">
            <div className="dashboard_container_class gap-10">
              <CourseLessonLeft video={video} />
              <CourseLessonRight items={items} setVideo={setVideo} />
            </div>
          </div>
        </section>
      )}
      <Footer />
    </Fragment>
  );
};

export default CourseLesson;
